import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
      formFunctionCode: 'cash_unfreezing_form',
      formParentCode: 'CRM20230411000000002',
    };
  },

  methods: {

    // 完成渲染
    formComplete() {
      if (this.formConfig.code === 'view') {
        request.post('/cps-mobile/v1/cash/dealer/thawed/findById', {
          id: this.formConfig.row.id,
        }).then((res) => {
          if (res.success) {
            this.setValue({
              ...res.result,
            });
          }
        });
      }
    },

    // 提交
    submit() {
      this.$emit('onClose');
    },
  },
};
